

<template>
    <div v-if="hasRun">
		<!--render the thermostats-->
        <div class="row boxover">
			<div class="col-md-4 col-md-offset-1 center-block"  v-for="(therm, index) in thermostats" :key="index">
				<div class="imgcontainer">
					<img class="main_image" :src="getImageSrc(therm.hvac_state)" style="z-index:0" alt="Thermostat Main Image"  />
					<img class="overlay_image level4" :src="getLeaf()" style="z-index:1;" v-if="therm.has_leaf" alt="Thermostat Overlay Image" />
					<div class="centered temp_font level2">{{therm.ambient_temperature}}</div>
					<div class="centered temperature-word level3">{{$t("message.target")}}: {{therm.target_temperature}}</div>
					<div class="name_font" style="left:55%;">{{therm.hvac_name}}</div>
				</div>
			</div>
        </div>

        <div v-if="thermostats === null || thermostats.length === 0">
            <h3 class="panel-title">{{$t("message.getNestThermostat")}}</h3><br /><br />
            <button class="btn btn-primary" @click="redirect(1)">{{$t("message.loginToNest")}}</button>
        </div>

    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: 'Thermostat',
        data() {
            return {
                thermostats: [],
                useFarenheit: true,
				hasRun: false,
				therm: null
            }
        },
        methods: {
			getImageSrc : function(hvac_state) 
			{
				switch (hvac_state) {
					case "cooling":
						return require('@/assets/img/nest-cooling.png');
						break;
					case "heating":
						return require('@/assets/img/nest-heating.png');
						break;
					default:
						return require('@/assets/img/nest-off.png');
						break;
				}
				
			},
			getLeaf: function() {
				return require('@/assets/img/NEST-leaf.png');
			},                 
            getCustomerThermostats: function() {
				var self = this;

                axios({
                    method: "POST",
                    url: this.$httpAxiosBaseUrl() + "thermostat/GetCustomerThermostats"
                }).then(result => 
                {
                    if (result !== null && result !== undefined)
                    {
						self.thermostats = [];
                        
                        for (var tc2 = 0; tc2 < result.data.length; tc2++)
                        {
							var curTherm2 = result.data[tc2];
							var therm = {

                              	ambient_temperature: curTherm2.currentTemp,
                              	target_temperature: curTherm2.targetTemp,
                              	has_leaf: curTherm2.isEco,
                              	away: !curTherm2.isOnline,
                              	hvac_state: curTherm2.hvacState,
                              	hvac_name: curTherm2.thermostatName,
							  	hvac_key: curTherm2.thermostatKey
							};
							self.thermostats.push(therm);
                        }
                    }
                    //This just makes the page show up, saying we're done.  It's OK if they found there is no therms to run.
                    self.hasRun = true;
                });
            },
            redirect(typeID) 
            {
                //All we do is open Nest's website.  The user will authorize them to load our data.  If they fail to do so and come back, they will receive an "authroization failed" error. 
                //Made flexible so we can do same for other thermostats in future.
                this.$store.commit('setLastThermostatID', -9);
                switch (typeID)
                {
                    case this.$thermostatTypes.Nest:
                        window.location = this.$authorizationURLs.NestAuthorization;
                        break;
                }
            }
        },
        mounted () {
            //I reset to -1 if we do not have an ID.  This implies they came back and did NOT register.  If they go through Therm Registration, we'll get an ID.
            //If they've been here before, we'll get an ID.  Otherwise we want a -1.
            var storeID = this.$store.getters.getLastThermostatID;
            if (storeID === -9)
            {
                //We need to alert them that the registration was unsuccesful.  We will otherwise load their Nests per usual.
                this.$toasted.global.error("Your last Nest authorization failed.  Please try again.");
                this.$store.commit('setLastThermostatID', -1);

			}

            this.getCustomerThermostats();

            //Set up so we run every 15 seconds to refresh the data.
			setInterval(function () {
		    	this.getCustomerThermostats();
			 }.bind(this), 15000);
        }
	}
</script>
<style scoped>
	.imgcontainer {
		position: relative;
		width: 300px;
		height: 350px;
	}
	.main_image {
		width: 100%;
		height: 100%;
		width: 300px;
		height: 300px;

	}
	.boxed {
		border-bottom: 1pt solid;
	}
	.boxover {
		margin-right: 15px;
		margin-left: 15px;
		align-content: center;
	}
	.overlay_image {
		position: absolute;
  		left: 50%;
  		transform: translate(-50%, -50%);
	}
	.temp_font {
		color: white;
		text-anchor: middle;
		font-family: Akkurat, Helvetica, sans-serif;
		font-size: 35px;
		font-weight:bold;
	}
	.name_font {
		color: black;
		text-anchor: middle;
		left: 50%;
		font-family: Akkurat, Helvetica, sans-serif;
		font-size: 20px;
		font-weight:bold;
		transform: translate(-50%, -50%);
		position: absolute;
		padding-top:25px;
	}
	.container {
  		position: relative;
  		text-align: center;
  		color: white;
	}

	/* Top left text */
	.temperature-word {
		color: white;
  		position: absolute;
  		transform: translate(-50%, -50%);
  		font-family: Helvetica, sans-serif;
  		font-size: 15px;
  		font-weight:bold;
	}
	/* Centered text */
	.centered {
  		position: absolute;
  		left: 50%;
  		transform: translate(-50%, -50%);
	}
	.level1
	{
		top: 20%
	}
	.level2
	{
		top: 30%
	}
	.level3
	{
		top: 40%
	}
	.level4
	{
		top: 50%
	}


</style>